import CookiesActionTypes from "./cookies.types";

// ------ ACTIONS ----- //
export const setIsCookieAccepted = isAccepted => ({
  type: CookiesActionTypes.SET_IS_COOKIE_ACCEPTED,
  payload: isAccepted,
});
